import { Injectable } from '@angular/core';
import { serverPort, base_url } from "../../../server/src/config/config";
import { Accounts } from "../models/Accounts";
import { Http, Response } from "@angular/http";
import 'rxjs/add/operator/map';

@Injectable()
export class AccountsService {

  constructor(private http: Http) {
  }

  create(accounts: Accounts) {
    return this.http.post(`${base_url}/v1/accounts`, accounts).map((response: Response) => response.json());
  }

  list() {
    return this.http.get(`${base_url}/v1/accounts`).map((response: Response) => response.json());
  }

  getById(_id) {
    return this.http.get(`${base_url}/v1/accounts?_id=${_id}`).map((response: Response) => response.json());
  }

  putById(_id, accounts: Accounts) {
    return this.http.put(`${base_url}/v1/accounts/${_id}`, accounts).map((response: Response) => response.json());
  }

  paymentById(_id, account) {
    return this.http.put(`${base_url}/v1/account_payment/${_id}`, account).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/accounts.service.ts